import { Ban } from "lucide-react";
import { cn } from "~/lib/utils";

interface CancellationMessageProps {
  className?: string;
}

/**
 * Renders the cancellation acknowledgment message from the backend.
 * Displayed when a user cancels a message generation.
 */
export function CancellationMessage({ className }: CancellationMessageProps) {
  return (
    <p className={cn("flex items-center gap-1.5 text-xs text-gray-700", className)}>
      <Ban className="size-3" />
      Request cancelled
    </p>
  );
}
